import { useState } from "react";
import { X, Sparkles } from "lucide-react";

const VOTE_URL = "https://app.emergent.sh/showcase/fabrizio/c0a05882-6ff3-4208-a803-2157c383f851";
// Auto-remove July 22, 2026 at 1:00 AM CDT (America/Chicago = UTC-5) → 06:00 UTC.
const CUTOFF = new Date("2026-07-22T06:00:00Z").getTime();

const MESSAGE = "🚀 We're going for #1 on Emergent — help San Antonio's Web Design secure funding for what's next. Please vote & share!";

export const VoteBanner = () => {
  const expired = Date.now() >= CUTOFF;
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem("voteBannerDismissed") === "1"; } catch { return false; }
  });
  if (expired || dismissed) return null;

  const close = () => {
    try { localStorage.setItem("voteBannerDismissed", "1"); } catch { /* ignore */ }
    setDismissed(true);
  };

  const items = Array.from({ length: 3 });
  return (
    <div className="relative bg-primary text-primary-foreground overflow-hidden" data-testid="vote-banner">
      <a href={VOTE_URL} target="_blank" rel="noopener noreferrer" data-testid="vote-banner-link"
         className="block group" aria-label="Vote for us on Emergent">
        <div className="flex whitespace-nowrap vote-marquee py-2">
          {items.map((_, i) => (
            <span key={i} className="mx-8 inline-flex items-center gap-2 text-sm font-semibold">
              <Sparkles className="h-4 w-4" /> {MESSAGE}
              <span className="underline underline-offset-2 group-hover:no-underline">Vote now →</span>
            </span>
          ))}
        </div>
      </a>
      <button onClick={close} data-testid="vote-banner-close" aria-label="Dismiss"
        className="absolute right-2 top-1/2 -translate-y-1/2 h-6 w-6 grid place-items-center rounded-full bg-black/20 hover:bg-black/30 transition-colors">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
